export default __webpack_public_path__ + "static/media/login2-bg.62a30c4f.png";